import BaseModel from '@core/model';

import AdviserExportIntegrationTypeEnum from '@constants/enums/adviser/exportIntegrationType';

export class AdviserExportIntegration extends BaseModel {
    static name = 'AdviserExportIntegration';
    static entity = 'adviserExportIntegrations';

    static fields() {
        return {
            id: this.attr(null),
            type: this.enum(AdviserExportIntegrationTypeEnum).nullable()
        };
    }
}

export default AdviserExportIntegration;
